import * as React from "react";
import type { SVGProps } from "react";
const SvgTransformAndReuse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M30.152 4.01a.875.875 0 0 1-.838.911c-9.512.4-15.44 4.484-19.027 9.381-3.614 4.934-4.882 10.744-4.937 14.56a.875.875 0 1 1-1.75-.025c.06-4.109 1.408-10.29 5.275-15.569 3.894-5.317 10.31-9.672 20.366-10.095.483-.02.89.354.91.837ZM30.152 58.855a.875.875 0 0 0-.838-.91c-9.512-.4-15.44-4.484-19.027-9.382C6.673 43.63 5.405 37.82 5.35 34.003a.875.875 0 0 0-1.75.026c.06 4.108 1.408 10.289 5.275 15.568 3.894 5.317 10.31 9.673 20.366 10.096.483.02.89-.355.91-.838Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m4.302 32.605 4.926 4.926A.875.875 0 1 1 7.99 38.77l-3.34-3.341-2.525 4.206a.875.875 0 0 1-1.5-.9l3.677-6.129ZM34.475 4.124a.875.875 0 0 0 .808.938c9.495.708 15.287 4.982 18.713 9.993 3.452 5.049 4.53 10.896 4.462 14.712a.875.875 0 0 0 1.75.032c.074-4.109-1.074-10.33-4.767-15.732-3.72-5.44-9.991-10.002-20.028-10.75a.875.875 0 0 0-.938.807Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m59.458 31.2-4.764-5.083a.875.875 0 0 1 1.277-1.197l3.231 3.448 2.66-4.122a.875.875 0 0 1 1.47.949L59.458 31.2ZM31.593 4.149 26.489 8.86a.875.875 0 0 1-1.187-1.286l3.465-3.2-4.078-2.7a.875.875 0 0 1 .966-1.458l5.938 3.932ZM33.559 60.019a.875.875 0 0 1 .833-.916c9.51-.448 15.418-4.561 18.98-9.477 3.589-4.952 4.827-10.768 4.862-14.584a.875.875 0 0 1 1.75.016c-.038 4.11-1.355 10.296-5.195 15.595-3.867 5.337-10.261 9.725-20.315 10.198a.875.875 0 0 1-.915-.832Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m32.113 59.888 5.08-4.738a.875.875 0 0 1 1.194 1.28l-3.449 3.217 4.091 2.679a.875.875 0 0 1-.958 1.464l-5.958-3.902Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="m45.16 24.683-8.456-8.83v8.83h8.456Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M20.015 15.693a4.208 4.208 0 0 1 2.976-1.233h13.333c.232 0 .455.093.619.257l10 10a.875.875 0 0 1 .256.618v20a4.208 4.208 0 0 1-4.208 4.209h-20a4.208 4.208 0 0 1-4.209-4.209V18.67c0-1.116.444-2.187 1.233-2.976Zm2.976.517a2.458 2.458 0 0 0-2.459 2.459v26.666a2.458 2.458 0 0 0 2.459 2.459h20a2.459 2.459 0 0 0 2.458-2.459V25.698l-9.487-9.488H22.99Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M36.323 14.46c.483 0 .875.392.875.875v9.125h9.125a.875.875 0 1 1 0 1.75h-10a.875.875 0 0 1-.875-.875v-10c0-.483.392-.875.875-.875Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M26.323 28.252c0-.69.56-1.25 1.25-1.25h4.76a1.25 1.25 0 0 1 0 2.5h-4.76c-.69 0-1.25-.56-1.25-1.25ZM26.323 35.252c0-.69.56-1.25 1.25-1.25h13.334a1.25 1.25 0 0 1 0 2.5H27.573c-.69 0-1.25-.56-1.25-1.25ZM26.323 42.252c0-.69.56-1.25 1.25-1.25h13.334a1.25 1.25 0 0 1 0 2.5H27.573c-.69 0-1.25-.56-1.25-1.25Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTransformAndReuse;
